import React from 'react';
import { View } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import LHModalPop from '../../../components/LHModalPop';
import { RootState } from '../../../store';
import { hideErrorModal, removeErrorById } from '../../../store/slices/rackingInspectionSlice';

const getApiTitle = (apiName?: string): string => {
  if (!apiName) return 'Error';
  const words = apiName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
  return `${words} Failed`;
};

const RackingInspectionErrorModal: React.FC = () => {
  const dispatch = useDispatch();
  const centralized = useSelector((state: RootState) => (state as any).rackingInspection?.centralizedErrors || { activeError: null, isErrorModalVisible: false });
  const { activeError, isErrorModalVisible } = centralized;

  const handleClose = () => {
    if (activeError) {
      try { dispatch(removeErrorById(activeError.id)); } catch (e) { /* swallow */ }
    }
    try { dispatch(hideErrorModal()); } catch (e) { /* swallow */ }
  };

  if (!activeError) return null;

  return (
    <LHModalPop
      visible={isErrorModalVisible}
      onClose={handleClose}
      title={getApiTitle(activeError.apiName)}
      description={activeError.message}
      showFooter={true}
      primaryButtonText="OK"
      secondaryButtonText=""
      onPrimaryPress={handleClose}
      showCloseButton={true}
    />
  );
};

export default RackingInspectionErrorModal;
